import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { FC } from "react";
import { BsCardImage } from "react-icons/bs";
import CardTitle from "../CardTitle";
import { CardWrapper } from "../PersonalInfo/PersonalInfo.styled";
import { Photo, PhotoGrid } from "./PhotosAndVideos.styled";
import { usePhotosAndVideos } from "./usePhotosAndVideos";

export const PhotosAndVideos: FC = () => {
    const { portfolioImages, handleError } = usePhotosAndVideos();

    return (
        <CardWrapper>
            <CardTitle
                icon={<BsCardImage />}
                title="Photos"
                editRoute={
                    routeConstants.profile.editProfile.root +
                    routeConstants.profile.editProfile.photosAndVideos
                }
            />
            {/* <Grid row={true} columnGap={1}>
                <Link variant="button2" isActive>
                    Photos
                </Link>
                <Link variant="button2" isActive={false}>
                    Videos
                </Link>
            </Grid> */}
            <PhotoGrid>
                {portfolioImages && portfolioImages.length > 0 ? (
                    portfolioImages.map((image) => (
                        <Photo
                            src={image.url}
                            alt="Model Image"
                            onError={handleError}
                        />
                    ))
                ) : (
                    <Text variant="body1">No images found.</Text>
                )}
            </PhotoGrid>
        </CardWrapper>
    );
};
